import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponent } from '@shared/component/base/base.component';
import {  MAT_DIALOG_DATA,  MatDialogRef } from '@angular/material/dialog';
import { SoleInvoiceTemplate } from 'taxtank-core';

/**
 * Dialog component with Sole Invoice Template add/edit form
 */
@Component({
  selector: 'app-invoice-template-form-dialog',
  templateUrl: './invoice-template-form-dialog.component.html',
  styleUrls: ['./invoice-template-form-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InvoiceTemplateFormDialogComponent extends BaseComponent {
  public invoiceTemplate = inject<SoleInvoiceTemplate>(MAT_DIALOG_DATA);
  public dialogRef = inject(MatDialogRef<InvoiceTemplateFormDialogComponent>);

}
